import cart from '../helpers/cart-helper'
import refs from '../helpers/refs'
import datalayer from '../helpers/datalayer'
import ButtonHelper from '../helpers/button-helper'

class MProductCard {
  constructor (el) {
    this.card = el
    this.$refs = refs(this.card)

    this.productHandle = this.card.dataset.productHandle
    this.variantID = this.card.dataset.variantId

    this.timeout = null

    this.init()
  }

  init () {
    // Add to cart button won't exist if out of stock
    if (this.$refs.cardAddToCartButton) {
      const button = this.$refs.cardAddToCartButton
      const innerElem = button.children.length > 0 ? button.children[0] : button
      const buttonHelper = new ButtonHelper(button, innerElem)

      button.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        // Set text to loading
        buttonHelper.setPendingState()

        cart
          .addProductsToCart([
            {
              id: this.variantID,
              quantity: 1
            }
          ])
          .then(() => {
            // Done adding to cart state
            buttonHelper.setDoneState()

            // Reset to initial state
            buttonHelper.resetStateOnDelay()
          })
      })
    }

    if (this.$refs.detailsOverlay) {
      this.$refs.detailsOverlay.addEventListener('mouseleave', (e) => {
        this.timeout = setTimeout(() => {
          this.hideDetailsOverlay()
        }, 300)
      })

      this.$refs.detailsOverlay.addEventListener('mouseenter', (e) => {
        clearTimeout(this.timeout)
      })
    }

    if (this.$refs.openOverlay) {
      this.$refs.openOverlay.addEventListener('click', (e) => {
        this.toggleDetailsOverlay()
      })

      // on mouse leave, hide the overlay
      this.$refs.openOverlay.addEventListener('mouseleave', (e) => {
        this.timeout = setTimeout(() => {
          this.hideDetailsOverlay()
        }, 300)
      })

      // on mouse enter, show the overlay
      this.$refs.openOverlay.addEventListener('mouseenter', (e) => {
        this.showDetailsOverlay()
      })
    }

    if (this.$refs.closeOverlay) {
      this.$refs.closeOverlay.addEventListener('click', (e) => {
        this.hideDetailsOverlay()

        /*
        e.path[1].classList.replace('flex', 'hidden')
        const overlay = document.getElementById('c-slider-pdp__overlay')

        if (overlay) {
          const sliders = document.getElementsByClassName(
            'm-product-card__buttons'
          )

          for (let i = 0; i < sliders.length; i++) {
            if (sliders[i].childElementCount === 3) {
              sliders[i].appendChild(overlay.firstChild)
              sliders[i].appendChild(
                document.getElementsByClassName('m-product-card__buttons')[i]
                  .children[2]
              )
              break
            }
          }
        }
        */
      })
    }

    // links around images and titles
    if (this.$refs.productLink) {
      this.$refs.productLink.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        let targetUrl
        const cardNode = e.target.closest('div.m-product-card')
        const position = cardNode.dataset.productPosition

        // target may be an image, h4 or an anchor depending on the exact spot clicked
        // find the nearest anchor element grab the href
        if (e.target instanceof HTMLAnchorElement) {
          targetUrl = e.target.href
        } else {
          targetUrl = e.target.closest('a').href
        }

        if (this.productHandle) {
          return new Promise((resolve, reject) => {
            datalayer.getProductByHandle(this.productHandle)
              .then((response) => {
                // console.log('Product click data response:', response)
                return response
              })
              .then((data) => {
                // console.log('Product click data resolve:', data)

                datalayer.pushProductClickEvent(data, cardNode.dataset.productList, position, targetUrl)

                resolve()
              })
              .catch((err) => {
                console.error('Product click error:', err)

                reject(err)
              })
          })
        }
      })
    }

    // Look for any links in the details overlay
    // if there are, make those links open in a new tab
    if (this.$refs.detailsOverlay) {
      const links = this.$refs.detailsOverlay.querySelectorAll('a')

      links.forEach((link) => {
        link.setAttribute('target', '_blank')
      })
    }
  }

  hideDetailsOverlay () {
    const detailsOverlay = this.$refs.detailsOverlay

    if (detailsOverlay !== null) {
      detailsOverlay.classList.replace('visible', 'invisible')
      detailsOverlay.classList.add('opacity-0')
    }
  }

  showDetailsOverlay () {
    const detailsOverlay = this.$refs.detailsOverlay

    if (detailsOverlay !== null) {
      detailsOverlay.classList.replace('invisible', 'visible')
      detailsOverlay.classList.remove('opacity-0')
    }

    clearTimeout(this.timeout)
  }

  toggleDetailsOverlay () {
    const detailsOverlay = this.$refs.detailsOverlay

    if (detailsOverlay !== null) {
      if (detailsOverlay.classList.contains('invisible')) {
        this.showDetailsOverlay()
      } else {
        this.hideDetailsOverlay()
      }
    }
  }
}

window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-m-product-card]')
    .forEach(el => new MProductCard(el))
})
